import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }

import {computed } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useReservationDaysStore } from '@/stores/ReservationDaysStore'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EventButton',
  props: {
    isScheduled:Boolean,
    scheduledHourCode:Number,
    date:String,
    dayName: String,
    dayMonth: String,
    day: String,
  },
  setup(__props) {

const props = __props;

  let { hourSelected,hourCode, dateSelected, dateSelectedFull } = storeToRefs(useReservationDaysStore())
  const reservationStore = useReservationDaysStore();
  const timeDictionary =reservationStore.timeDictionary;

  

    // a computed ref
  const computedTime = computed(() => {
    var hourcomputed = props.scheduledHourCode ? props.scheduledHourCode  as number : -1;
    return timeDictionary[hourcomputed as keyof typeof timeDictionary];
  })


  function selectDateHour(){
    hourSelected.value = computedTime.value;
    hourCode.value= props.scheduledHourCode;
    dateSelected.value = props.date;
    dateSelectedFull.value = props.dayName +" "+ props.day +" "+ props.dayMonth;
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "text-base p-1 bg-gray-200 text-black rounded w-full lg:text-xs hover:bg-gray-400",
      onClick: selectDateHour
    }, _toDisplayString(computedTime.value), 1)
  ]))
}
}

})